import {StyleSheet} from "react-native";

export const styles = StyleSheet.create({
   page: {
       flex: 1,
       justifyContent: 'center',
       alignItems: 'flex-start',
       marginVertical: 50,
       marginHorizontal: 85,
   },
    textInputContainer: {
        flexDirection: 'column',
        width: "100%"
    },
    selectInputContainer: {
        flexDirection: 'column',
        width: "100%"
    },
    subTitle: {
        fontSize: 16,
        color: '#000006',
        fontWeight: '700',
        fontFamily: 'Montserrat',
        marginBottom: 6
    },
    selectInput: {
        backgroundColor: 'white',
    },
    input: {
        borderWidth: 1,
        borderColor: '#979797',
        paddingVertical: 6,
        paddingHorizontal: 12,
        marginBottom: 20,
        borderRadius: 5,
    },
});